$(document).ready(function(){
  var video = document.querySelector('.video');
  var videoContainer = document.querySelector('.video-story');
  var selectedId = $('.blog-cat-nav select').data('selected-id');

  /* Select Correct tag in Dropdown */
  $('.blog-cat-nav option:selected').removeAttr('selected');
  $('.blog-navigation .selected').removeClass('selected');

  $('.blog-cat-nav option[name="' + selectedId + '"]').attr('selected','selected');
  $('.blog-navigation a[name="' + selectedId + '"]').addClass('selected');

  if(video) {
    videoContainer.addEventListener('click', function(e) {
      e.preventDefault();
      togglePlayPause(video, videoContainer);
    });
  }

  headerParallax();
});

new Swiper(".featured-articles--slider", {
  slidesPerView: 1,
  loop: true,
  speed: 450,
  pagination: {
    el: '.swiper-pagination',
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
})

new Swiper('.content .article-products-slider', {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  loopAddBlankSlides: false,
  navigation: {
    enabled: false
  },
  breakpoints: {
    769: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      loopAddBlankSlides: false,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }
  }
});

/* Article Featured Products Slider */
new Swiper('.featured-products .article-products-slider', {
  enabled: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  speed: 300,
  breakpoints: {
    769: {
      enabled: false,
    }
  }
});


$(window).on('resize orientationchange', function(){
  headerParallax();
});

function togglePlayPause(video, container) {
  if(video.paused) {
    container.classList.add('playing');
    video.play();
  } else {
    container.classList.remove('playing');
    video.pause();
  }
}

function headerParallax() {
  var viewportWidth = window.screen.width;
  if (viewportWidth > 1024) {
    /* Parallax for Header */
    window.addEventListener('scroll', function (e) {
      const heroParallaxTitle = document.querySelector('.inner-title');
      const heroParallaxImg = document.querySelector('.article-featured-img .article__image');
      var pos = window.pageYOffset * 0.08;
      var transp = window.pageYOffset * -0.004 + 1.5;
      heroParallaxTitle.style.transform = 'translate3d(0px,' + pos + 'px, 0px)';
      heroParallaxImg.style.opacity = transp;
    });
  } 
}
